import { QUERY as M } from "../../constants/query.js";
import T from "../generic/usePersistQuery.js";
const s = () => {
  T([
    M.UTM_CAMPAIGN,
    M.UTM_CONTENT,
    M.UTM_ID,
    M.UTM_MEDIUM,
    M.UTM_SOURCE,
    M.UTM_TERM
  ]);
};
export {
  s as default
};
//# sourceMappingURL=usePersistUTM.js.map
